import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesResellers } from "../../constants";
import { ResellerCommissionsResponse } from "../../resellers.types";
import { GetResellerCommissionsRequestParams } from "./getResellerCommissions.types";

export const requestGetResellerCommissions = async (
  resellerId: string,
  params: GetResellerCommissionsRequestParams
): Promise<ResellerCommissionsResponse> => {
  return await instance.get(
    buildUrl(
      ApiRoutesResellers.Reseller,
      resellerId,
      ApiRoutesResellers.ResellerCommissions
    ),
    { params }
  );
};
